// Reducers: specify how the application's state changes in response to actions
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_SUCCESS,
  USER_TX_REQUEST,
  USER_TX_SUCCESS,
  USER_TX_FAILURE,
  TOKEN_EXPIRED,
  USER_TX_ID_REQUEST,
  USER_TX_ID_SUCCESS,
  USER_TX_ID_FAILURE,
  USER_TX_STATE_UPDATE_SUCCESS,
  USER_TX_STATE_UPDATE_FAILURE,
  USER_TX_STATE_UPDATE_REQUEST,
  USER_TX_ID_RESET,
  USER_TX_REQUEST_INSIGHTS,
  USER_TX_SUCCESS_INSIGHTS,
  USER_TX_FAILURE_INSIGHTS,
  ACTIVATE_MFA_SUCCESS,
  CHECK_MFA_SUCCESS,
  CONFIRM_MFA_SUCCESS,
  CONFIRM_MFA_FAILURE,
  SET_EPHEMERAL_TOKEN,
  USER_TX_SUCCESS_INSIGHTS_FAST,
} from './actions'
import { APP_CONTEXT_SUCCESS_TX } from './actions/app_context'
import { ADDRESS_REQUEST, ADDRESS_REQUEST_SUCCESS } from './actions/address_validation'
import { STORAGE_TYPE_LOCAL } from './config'
import { API_JWT_TOKEN_NAME } from './middleware/api'
import StorageProviderFactory from './managers/storage_provider_factory'

// @todo split into separate reducer files

// The auth reducer. The starting state sets authentication
// based on a token being in local storage. In a real app,
// we would also want a util to check if the token is expired.

export function auth(
  state = {
    isFetching: false,
    isAuthenticated: !!StorageProviderFactory.create(STORAGE_TYPE_LOCAL).getItem(API_JWT_TOKEN_NAME),
    isTokenExpired: null,
    isLogoutSuccess: null,
  },
  action
) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isFetching: true,
        isAuthenticated: false,
        user: action.creds.username ? action.creds : state.user,
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        errorMessage: '',
        isTokenExpired: false,
      }
    case LOGIN_FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        errorMessage: action.message,
      }
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isFetching: true,
        isAuthenticated: false,
        isTokenExpired: true,
        isLogoutSuccess: true,
        ephemeralToken: null,
      }
    case ACTIVATE_MFA_SUCCESS:
      return {
        ...state,
        qrLink: action.response.qr_link,
      }
    case CONFIRM_MFA_SUCCESS:
      return {
        ...state,
        qrLink: null,
        confirmMfaError: null,
      }
    case CONFIRM_MFA_FAILURE:
      return {
        ...state,
        confirmMfaError: action.details.non_field_errors[0],
      }
    case CHECK_MFA_SUCCESS:
      return {
        ...state,
        mfaStatus: action.response.length > 0 ? 'Enabled' : 'Disabled',
      }
    case TOKEN_EXPIRED:
      return {
        ...state,
        isAuthenticated: false,
        isTokenExpired: true,
      }
    case SET_EPHEMERAL_TOKEN:
      return {
        ...state,
        ephemeralToken: action.token,
      }
    default:
      return state
  }
}

// The user TX reducer
export function tx(
  state = {
    isFetching: false,
    userTxs: null,
    errorMessage: null,
    count: 0,
    nextUrl: null,
    requestUrl: null,
  },
  action
) {
  switch (action.type) {
    case USER_TX_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
        userTxs: null,
      }
    case USER_TX_REQUEST_INSIGHTS:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case USER_TX_SUCCESS:
    case USER_TX_SUCCESS_INSIGHTS:
      return {
        ...state,
        isFetching: false,
        userTxs: action.response.results,
        count: action.response.count,
        nextUrl: action.response.next,
        errorMessage: null,
        requestUrl: action.requestUrl,
      }
    case USER_TX_SUCCESS_INSIGHTS_FAST:
      return {
        ...state,
        userTxs: action.response.results,
        nextUrl: action.response.next,
        errorMessage: null,
        requestUrl: action.requestUrl,
      }
    case USER_TX_FAILURE:
    case USER_TX_FAILURE_INSIGHTS:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.error,
        requestUrl: action.requestUrl,
      }
    default:
      return state
  }
}

// single user transaction
export function txById(
  state = {
    isFetching: false,
    userTx: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case USER_TX_ID_REQUEST:
      return {
        ...state,
        isFetching: true,
        userTx: null,
        errorMessage: null,
      }
    case USER_TX_ID_SUCCESS:
      return {
        ...state,
        isFetching: false,
        userTx: action.response,
        errorMessage: null,
      }
    case USER_TX_ID_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.error,
      }
    case USER_TX_ID_RESET:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        userTx: null,
      }
    case APP_CONTEXT_SUCCESS_TX:
      return {
        ...state,
        userTx: {
          ...state.userTx,
          appContext: action.response,
        },
      }
    case ADDRESS_REQUEST_SUCCESS:
      return {
        ...state,
        userTx: {
          ...state.userTx,
          validationAddress: action.data.Records ? action.data.Records[0] : null,
        },
      }
    case ADDRESS_REQUEST:
      return {
        ...state,
        userTx: {
          ...state.userTx,
          validationAddress: null,
        },
      }
    default:
      return state
  }
}

// api update tx state
export function txState(
  state = {
    isFetching: false,
    responseData: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case USER_TX_STATE_UPDATE_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case USER_TX_STATE_UPDATE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        responseData: action.response,
        errorMessage: null,
      }
    case USER_TX_STATE_UPDATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}
